module.exports = __webpack_public_path__ + "img/info.80fbac5e.svg";